import { Action } from 'redux'
import { ReduxAction } from '../ReduxUtils'
import { JsngSelected, JSNG_SELECTED } from './JackpotSitAndGoEntriesAction'

export interface JackpotSitAndGoEntriesState {
    selectedNameId: string;
}

const initialState: JackpotSitAndGoEntriesState = {
	selectedNameId: '',
}

export const jackpotSitAndGoEntriesReducer = (
	state: JackpotSitAndGoEntriesState = initialState,
	reduxAction: Action,
): JackpotSitAndGoEntriesState => {
	const action: ReduxAction<any> = reduxAction as ReduxAction<any>
	switch (action.type) {
	case JSNG_SELECTED:
		const jsngSelected = action.payload as JsngSelected
		return { ...state, selectedNameId: jsngSelected.nameId }
	default:
		return state
	}
}
